import { colors } from '../utils/theme';
import Link from 'next/link';
import React from 'react';
import { GQLApp } from 'townapps-models/graphql/types';
import Image from 'next/image';

type Props = {
  app: GQLApp;
};

const FeaturedBusinessesSection: React.FC<Props> = ({ app }) => {
  return (
    <div className="xplore-section mt-32">
      <h2 className="xplore-title !mb-3">Gnóthaí Áitiúla / Local Businesses</h2>
      <p className="xplore-subtitle mb-16">
        Discover the eclectic mix of charming businesses your town has to offer — everything from coffee shops to hairdressers to hotels.
      </p>

      <div className="flex items-center justify-end mb-4">
        <Link href={`/${app.slug}/listings`} passHref>
          <a
            style={{ color: colors.lightGreen }}
            className="cursor-pointer text-right font-bold text-md mb-0 mt-0"
            onClick={() => {
              sessionStorage.setItem('selectedTags', '[]');
            }}>
            Tuilleadh - See All{' '}
          </a>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row w-full h-[800px] md:h-[500px]">
        <Link href={`/${app.slug}/listings`} passHref>
          <a
            onClick={() => {
              sessionStorage.setItem(`selectedTags`, JSON.stringify(['shopping']));
            }}
            className="cursor-pointer w-full mb-4 md:mb-0 md:w-1/2 md:mr-3  h-full relative rounded-xl md:!rounded-br-none md:!rounded-tr-none overflow-hidden">
            <Image src="/shopping.jpeg" layout="fill" objectFit="cover" alt="Shopping Image" />
            <div className="w-full flex p-2 h-10 items-center bottom-0 absolute" style={{ backgroundColor: 'rgba(0, 191, 166, 0.8)' }}>
              <span className="text-white font-bold">Siopaí – Shopping</span>
            </div>
          </a>
        </Link>
        <div className="w-full md:w-1/2 md:ml-3 flex flex-col h-full justify-between  rounded-tr-xl overflow-hidden">
          <Link passHref href={`/${app.slug}/listings`}>
            <a
              onClick={() => {
                sessionStorage.setItem(`selectedTags`, JSON.stringify(['restaurant']));
              }}
              className="cursor-pointer w-full h-[155px] relative rounded-xl md:rounded-none overflow-hidden mb-4 md:mb-0">
              <Image src="/fooddrink.jpeg" layout="fill" objectFit="cover" alt="Food & Drink Image" />
              <div className="w-full flex p-2 h-10 items-center bottom-0 absolute" style={{ backgroundColor: 'rgba(0, 191, 166, 0.8)' }}>
                <span className="text-white font-bold">Bia & Deochanna – Food & Drink</span>
              </div>
            </a>
          </Link>

          <Link passHref href={`/${app.slug}/listings`}>
            <a
              onClick={() => {
                sessionStorage.setItem(`selectedTags`, JSON.stringify(['lifestyle']));
              }}
              className="w-full h-[155px] relative rounded-xl md:rounded-none overflow-hidden mb-4 md:mb-0">
              <Image src="/lifestyle.jpeg" layout="fill" objectFit="cover" alt="Life style Image" />
              <div className="w-full flex p-2 h-10 items-center bottom-0 absolute" style={{ backgroundColor: 'rgba(0, 191, 166, 0.8)' }}>
                <span className="text-white font-bold">Nós maireachtála – Lifestyle</span>
              </div>
            </a>
          </Link>

          <Link passHref href={`/${app.slug}/listings`}>
            <a
              onClick={() => {
                sessionStorage.setItem(`selectedTags`, JSON.stringify(['accommodation']));
              }}
              className="w-full h-[155px] relative rounded-xl md:rounded-none md:rounded-br-xl overflow-hidden mb-4 md:mb-0">
              <Image src="/lodging.jpeg" layout="fill" objectFit="cover" alt="Accommodation Image" />
              <div className="w-full flex p-2 h-10 items-center bottom-0 absolute" style={{ backgroundColor: 'rgba(0, 191, 166, 0.8)' }}>
                <span className="text-white font-bold">Lóistín - Accommodation</span>
              </div>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedBusinessesSection;
